import React from "react";
import { Link } from "react-router";

import { url, path, routes } from "oo-routes";

import "./styles";
import LOGO from "./logo.png";
import Testimonials from "./Testimonials";

export default class Footer2 extends React.Component {
  static propTypes = {};

  state = {};

  render() {
    return (
      <div className="Footer2">
        {!this.props.hideTestimonials && (
          <Testimonials user={this.props.user} />
        )}
        <div className="ui container links">
          <div className="top">
            <div className="p-v-2" />
            <div className="p-v-2 computer-only" />
            <div className="ui grid">
              <div className="three wide computer three wide tablet six wide mobile column">
                <h3 className="m-b-1">RESOURCES</h3>
                <div className="m-b-0_5">
                  <a href="https://scalablepress.com/catalog">Catalog</a>
                </div>
                {/*<div className="m-b-0_5">
                  <Link to={path(routes.website2.home.pricing)}>
                    Pricing
                  </Link>
                </div>*/}
                {/* }
                <Link className="m-b-0_5">
                  Quality
                </Link>
                { */}
                {/* }
                <div className="m-b-0_5">
                  <a href={url('website', routes.website.status.base)}>
                    Turnaround times
                  </a>
                </div>
                { */}
                {/* }
                <Link className="m-b-0_5">
                  Shipping options
                </Link>
                { */}
                {/* }
                <div className="m-b-0_5">
                  <a href="https://resources.scalablepress.com/knowledge">
                    Knowledge Base
                  </a>
                </div>
                { */}
                {/*<div className="m-b-0_5">
                  <a href="https://blog.scalablepress.com">
                    Blog
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href="https://blog.scalablepress.com/video-tutorials">
                    Video tutorials
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href="https://blog.scalablepress.com/frequently-asked-questions">
                    FAQs
                  </a>
                </div>*/}
                {/* }
                <Link className="m-b-0_5">
                  Mockup generator
                </Link>
                { */}
              </div>
              <div className="three wide computer three wide tablet six wide mobile column">
                <h3 className="m-b-1">DECORATION</h3>
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.screenprint)}>
                    Screen printing
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.dtg)}>
                    DTG printing
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.sublimation)}>
                    Sublimation
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.poster)}>
                    Poster printing
                  </a>
                </div>
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.embroidery)}>
                    Embroidery
                  </a>
                </div>
                {/* }
                <Link className="m-b-0_5">
                  Embroidery
                </Link>
                <Link className="m-b-0_5">
                  Laser etching
                </Link>
                <Link className="m-b-0_5">
                  Whitelabel fulfillment
                </Link>
                { */}
              </div>
              <div className="three wide computer three wide tablet six wide mobile column">
                <h3 className="m-b-1">INTEGRATIONS</h3>
                {/*<div className="m-b-0_5">
                  <a href={url('website', routes.website2.home.shopify)}>
                    Shopify
                  </a>
                </div>*/}
                {/*<div className="m-b-0_5">
                  <a href={url('website', routes.website2.home.woocommerce)}>
                    WooCommerce
                  </a>
                </div>*/}
                <div className="m-b-0_5">
                  <a href={url("website", routes.website2.home.api)}>API</a>
                </div>
                <div className="m-b-0_5">
                  <a href="https://scalablepress.com/catalog">
                    Online ordering
                  </a>
                </div>
              </div>
              <div className="three wide computer three wide tablet six wide mobile column">
                <h3 className="m-b-1">COMPANY</h3>
                {/*
                <div className="m-b-0_5">
                  <a href={url('website', routes.website.company.about)}>
                    About us
                  </a>
                </div>
                */}
                <div className="m-b-0_5">
                  <Link to={path(routes.website2.home.careers.base)}>
                    Careers
                  </Link>
                </div>
                {/* }
                <Link className="m-b-0_5">
                  Compare us
                </Link>
                { */}
              </div>
            </div>
            <div className="p-v-2 computer-only" />
            <div className="p-v-2" />
          </div>
          <div className="bottom p-v-1_5">
            <div className="ui mobile vertically reversed grid">
              <div className="six wide computer six wide tablet twelve wide mobile column center-aligned-m">
                <div className="copyright">
                  <img src={LOGO} className="m-r-0_5 d-ib" />
                  <div className="d-ib">&copy; Scalable Press</div>
                </div>
              </div>
              <div className="six wide computer six wide tablet twelve wide mobile right aligned column column center-aligned-m">
                <a
                  href={url("website", routes.website.company.privacy)}
                  className="computer-only tablet-only"
                >
                  Privacy
                </a>
                <a
                  href={url("website", routes.website.company.terms)}
                  className="m-l-1_5 computer-only tablet-only"
                >
                  Terms of use
                </a>
                <a
                  href="https://www.youtube.com/channel/UChgbj4qI33PmPJ_DNEqddSg"
                  className="m-l-1_5"
                >
                  <i className="youtube icon" />
                </a>
                {/*
                  <a href="https://www.facebook.com/scalablepressofficial" className="m-l-1_5">
                    <i className="facebook icon" />
                  </a>
                */}
                <a href="https://twitter.com/scalablepress" className="m-l-1_5">
                  <i className="twitter icon" />
                </a>
                <a
                  href="https://www.instagram.com/scalablepress/"
                  className="m-l-1_5"
                >
                  <i className="instagram icon" />
                </a>
                <a
                  href="https://www.linkedin.com/company/4864727/"
                  className="m-l-1_5"
                >
                  <i className="linkedin icon" />
                </a>
                <div className="mobile-only m-t-1_5">
                  <a
                    href={url("website", routes.website.company.privacy)}
                    className="m-r-1_5"
                  >
                    Privacy
                  </a>
                  <a href={url("website", routes.website.company.terms)}>
                    Terms of use
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Footer2/index.jsx